import React, { memo } from 'react';
import { CalendarIcon, UsersIcon, MicIcon, StarIcon, BookOpenIcon, AwardIcon } from 'lucide-react';
export function Features() {
  return <section id="features" className="py-20 bg-gray-50" data-id="element-148">
      <div className="container mx-auto px-4" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-151">
            Planned Program Features
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-152">
            Our proposed music collective will offer a range of activities and
            opportunities designed to support and showcase the talents of our
            members.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-153">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-154">
            <CalendarIcon size={28} className="text-indigo-600 mb-4" data-id="element-155" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-156">
              Regular Sessions
            </h3>
            <p className="text-gray-600" data-id="element-157">
              Weekly practice sessions in a supportive environment with guidance
              from experienced mentors, serving as a meaningful alternative to
              traditional day programs.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-158">
            <UsersIcon size={28} className="text-indigo-600 mb-4" data-id="element-159" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-160">
              Collaborative Projects
            </h3>
            <p className="text-gray-600" data-id="element-161">
              Opportunities to collaborate with other musicians in small groups
              and ensemble settings within the Cherry Hill area.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-162">
            <MicIcon size={28} className="text-indigo-600 mb-4" data-id="element-163" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-164">
              Performance Opportunities
            </h3>
            <p className="text-gray-600" data-id="element-165">
              Concerts at nursing homes, memory care facilities, schools, and
              public events where members can showcase their talents.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-166">
            <StarIcon size={28} className="text-indigo-600 mb-4" data-id="element-167" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-168">
              Skill Development
            </h3>
            <p className="text-gray-600" data-id="element-169">
              Workshops focused on advancing musical skills, performance
              techniques, and artistic expression with potential for vocational
              opportunities.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-170">
            <BookOpenIcon size={28} className="text-indigo-600 mb-4" data-id="element-171" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-172">
              Personalized Support
            </h3>
            <p className="text-gray-600" data-id="element-173">
              Individualized guidance that respects each musician's unique needs
              and learning style within a cost-sharing model.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-174">
            <AwardIcon size={28} className="text-indigo-600 mb-4" data-id="element-175" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-176">
              Community Connection
            </h3>
            <p className="text-gray-600" data-id="element-177">
              Become part of a supportive community that celebrates
              neurodiversity in music and creates meaningful social connections.
            </p>
          </div>
        </div>
      </div>
    </section>;
}